module.exports = __webpack_public_path__ + "img/Image1.06956338.png";